import { Box, Input, Typography } from '@mui/joy';

const TimeInput = ({ label, labelMinWidth, defaultValue, disabled, name, required }) => {

  return (
    <Box display='flex'>
      <Typography sx={{ minWidth: labelMinWidth, alignSelf: "center" }}>
          {label}: 
      </Typography>
      <Box
        pl='10px'
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          my: 1,
        }}
      >
        <Input
        name={name}
        required={required}
        type="time"
        defaultValue={defaultValue}
        disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default TimeInput;